import { inject, Injectable, NgZone} from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface LmsMessage {
	type: string;
	payload?: any;
}

export type AllowedLmsParentApp = 'lms_scorm';
export type LmsParentMessage = 'scormReady' | 'scormInitializationFailed';

@Injectable({ providedIn: 'root' })
export class LmsMessageBus {
	private readonly parentMessage$ = new Subject<LmsMessage>();
	private readonly zone: NgZone = inject(NgZone);
	private readonly parentOrigin: string | null = null;

	constructor() {
		this.parentOrigin = new URL(document.referrer).origin;
	}

	public subscribeLmsParent(parentApp: AllowedLmsParentApp, messageTypes: LmsParentMessage[]): Observable<LmsMessage> {
		window.addEventListener('message', (event: MessageEvent) => {
			if (this.parentOrigin !== event.origin) {
				return;
			}

			if (event.data.app !== parentApp) {
				return;
			}

			if (!event.data || !messageTypes.includes(event.data.type)) {
				return;
			}
			const { type, payload } = event.data || {};

			this.zone.run(() => {
				this.parentMessage$.next({ type, payload });
			});
		});

		return this.parentMessage$.asObservable();
	}
}
